import {
  USER_LIST_FAILED,
  USER_LIST_LOAD,
  USER_LIST_LOADING,
  USER_LIST_SUCCESS,
} from '../constants/UserListConst';

export const success = (data) => {
  return {
    type: USER_LIST_SUCCESS,
    data,
  };
};

export const failed = () => {
  return {
    type: USER_LIST_FAILED,
  };
};

export const loading = () => {
  return {
    type: USER_LIST_LOADING,
  };
};

export const loaduserlist = ({ page: page, filter: filter }) => {
  return {
    type: USER_LIST_LOAD,
    page,
    filter,
  };
};
